import { PROFILER_SEARCH_CATEGORIES } from '../../../../utils/constants/searchCategories';
import { PROFILER_SEARCH_FIELDS } from '../../../../utils/constants/fields';
import Input from '../../../../components/inputs/Input';
import CityZipAutocompleteInput from '../../../../components/inputs/CityZipAutocompleteInput';
import RangeInput from '../../../../components/inputs/RangeInput';
import MultiSelect from '../../../../components/inputs/MultiSelect';
import OwnershipInfoButton from '../../../../components/profiler/ownership/OwnershipInfoButton';
import {
  isProfilerAdvancedCriteriaDisabled,
  isProfilerAdvancedCriteriaOwnershipDisabled
} from '../../../../utils/constants/variables';

export const getProfilerCompanyCriteriaSearchFields = (state) => {
  // const disableInputsByLoader = state.isLoading || state.isInitialLoading;
  const disableInputsByDemoExceedLimit = state.isProfilerCompanyCriteriaSearchFieldsDisabled;

  // The ownership chain position is required, and only enabled, with a structure.
  const hasOwnershipStructure = !!state.profilerCompanyCriteriaFields[
    PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
  ]?.length;

  return {
    [PROFILER_SEARCH_FIELDS.INDUSTRY.ID]: (
      <Input
        field={PROFILER_SEARCH_FIELDS.INDUSTRY}
        value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.INDUSTRY.NAME]}
        setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
        // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
        disabled={disableInputsByDemoExceedLimit}
        messages={state.profilerCompanyCriteriaValidationFields.messages}
        showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
        inputWrap={{ enable: true, className: 'col' }}
      />
    ),
    [PROFILER_SEARCH_FIELDS.VALUE_CHAIN.ID]: (
      <Input
        field={PROFILER_SEARCH_FIELDS.VALUE_CHAIN}
        value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.VALUE_CHAIN.NAME]}
        setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
        // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
        disabled={disableInputsByDemoExceedLimit}
        messages={state.profilerCompanyCriteriaValidationFields.messages}
        showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
        inputWrap={{ enable: true, className: 'col' }}
      />
    ),
    [PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO.ID]: (
      <Input
        field={PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO}
        value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO.NAME]}
        setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
        // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
        disabled={disableInputsByDemoExceedLimit}
        messages={state.profilerCompanyCriteriaValidationFields.messages}
        showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
        inputWrap={{ enable: true, className: 'col' }}
      />
    ),
    [PROFILER_SEARCH_FIELDS.REVENUE_MIN.ID + PROFILER_SEARCH_FIELDS.REVENUE_MAX.ID]: (
      <RangeInput
        fieldMin={PROFILER_SEARCH_FIELDS.REVENUE_MIN}
        fieldMax={PROFILER_SEARCH_FIELDS.REVENUE_MAX}
        valueMin={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MIN.NAME]}
        valueMax={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MAX.NAME]}
        setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
        // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
        disabled={disableInputsByDemoExceedLimit}
        messages={state.profilerCompanyCriteriaValidationFields.messages}
        showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
        wrapClass={'col'}
      />
    ),
    [PROFILER_SEARCH_CATEGORIES.ADVANCED_SEARCH_CRITERIA]: {
      [PROFILER_SEARCH_FIELDS.CAGR_MIN.ID + PROFILER_SEARCH_FIELDS.CAGR_MAX.ID]: (
        <RangeInput
          fieldMin={PROFILER_SEARCH_FIELDS.CAGR_MIN}
          fieldMax={PROFILER_SEARCH_FIELDS.CAGR_MAX}
          valueMin={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MIN.NAME]}
          valueMax={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MAX.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          messages={state.profilerCompanyCriteriaValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
          wrapClass={'col'}
        />
      ),
      [PROFILER_SEARCH_FIELDS.CAGR_PERIOD.ID]: (
        <MultiSelect
          field={PROFILER_SEARCH_FIELDS.CAGR_PERIOD}
          value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_PERIOD.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
          withSingleClear
          forceRequired={
            !!state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MIN.NAME] ||
            !!state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MAX.NAME]
          }
          disabled={
            disableInputsByDemoExceedLimit ||
            (!state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MIN.NAME] &&
              !state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CAGR_MAX.NAME])
          }
        />
      ),
      // Profiler Lite has no EBIT-margin data (withheld server-side), so the
      // EBIT-margin range is dropped from the "Adjust search" criteria. CAGR stays.
      ...(state.isProfilerLiteOnly
        ? {}
        : {
            [PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MIN.ID + PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MAX.ID]:
              (
                <RangeInput
                  fieldMin={PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MIN}
                  fieldMax={PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MAX}
                  valueMin={
                    state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MIN.NAME]
                  }
                  valueMax={
                    state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.EBIT_MARGIN_MAX.NAME]
                  }
                  setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
                  disabled={disableInputsByDemoExceedLimit}
                  messages={state.profilerCompanyCriteriaValidationFields.messages}
                  showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
                  wrapClass={'col'}
                />
              )
          }),
      [PROFILER_SEARCH_FIELDS.EMPLOYEES_MIN.ID + PROFILER_SEARCH_FIELDS.EMPLOYEES_MAX.ID]: (
        <RangeInput
          fieldMin={PROFILER_SEARCH_FIELDS.EMPLOYEES_MIN}
          fieldMax={PROFILER_SEARCH_FIELDS.EMPLOYEES_MAX}
          valueMin={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.EMPLOYEES_MIN.NAME]}
          valueMax={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.EMPLOYEES_MAX.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          messages={state.profilerCompanyCriteriaValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
          wrapClass={'col'}
        />
      ),
      [PROFILER_SEARCH_FIELDS.HEADQUARTER.ID]: (
        <MultiSelect
          field={PROFILER_SEARCH_FIELDS.HEADQUARTER}
          value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.HEADQUARTER.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
          withSingleClear
        />
      ),
      [PROFILER_SEARCH_FIELDS.SITUATION.ID]: (
        <MultiSelect
          field={PROFILER_SEARCH_FIELDS.SITUATION}
          value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.SITUATION.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={disableInputsByDemoExceedLimit}
          inputWrap={{ enable: true, className: 'col' }}
        />
      ),
      [PROFILER_SEARCH_FIELDS.LISTING_STATUS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_SEARCH_FIELDS.LISTING_STATUS}
            labelAddon={<OwnershipInfoButton />}
            value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.LISTING_STATUS.NAME]}
            setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
            disabled={disableInputsByDemoExceedLimit}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      [PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES}
            value={
              state.profilerCompanyCriteriaFields[
                PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES.NAME
              ]
            }
            setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
            disabled={disableInputsByDemoExceedLimit}
            inputWrap={{ enable: true, className: 'col' }}
          />
        ),
      // Like CAGR period: disabled until a structure is chosen, then required.
      [PROFILER_SEARCH_FIELDS.OWNERSHIP_BASIS.ID]:
        isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled ? null : (
          <MultiSelect
            field={PROFILER_SEARCH_FIELDS.OWNERSHIP_BASIS}
            value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.OWNERSHIP_BASIS.NAME]}
            setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
            withSingleClear
            inputWrap={{ enable: true, className: 'col' }}
            forceRequired={hasOwnershipStructure}
            disabled={disableInputsByDemoExceedLimit || !hasOwnershipStructure}
          />
        ),
      [PROFILER_SEARCH_FIELDS.CITY_ZIPCODE.ID]: (
        <CityZipAutocompleteInput
          field={PROFILER_SEARCH_FIELDS.CITY_ZIPCODE}
          value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CITY_ZIPCODE.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          countries={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.HEADQUARTER.NAME]}
          messages={state.profilerCompanyCriteriaValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
          inputWrap={{ enable: true, className: 'col' }}
          disabled={
            disableInputsByDemoExceedLimit ||
            !(
              state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.HEADQUARTER.NAME]?.length >
              0
            )
          }
        />
      ),
      [PROFILER_SEARCH_FIELDS.DISTANCE.ID]: (
        <Input
          field={PROFILER_SEARCH_FIELDS.DISTANCE}
          value={state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.DISTANCE.NAME]}
          setFieldValue={state.setProfilerCompanyCriteriaFieldValue}
          // disabled={disableInputsByLoader || disableInputsByDemoExceedLimit}
          disabled={
            disableInputsByDemoExceedLimit ||
            !state.profilerCompanyCriteriaFields[PROFILER_SEARCH_FIELDS.CITY_ZIPCODE.NAME]?.trim()
          }
          messages={state.profilerCompanyCriteriaValidationFields.messages}
          showOnSubmitErrorState={state.onProfilerCompanyCriteriaSubmitErrorState}
          inputWrap={{ enable: true, className: 'col' }}
        />
      )
    }
  };
};
